/**
 * Service: Point of Sale API
 */
angular.module('acme.common.service.posApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('PosApiService', ['$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {
      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/pos/config';
        this.images.service = this.service;
        this.pages.service = this.service;

        return this;
      },

      list: function (props) {
        var q = '', url = this.service;

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }
        //temp route this will change once endpoint is ready
        return $http({
          method: 'GET',
          url: this.service.replace(/v1/, 'v2') + q
        });

      },

      detail: function(id) {
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + '/' + id
        });
      },

      remove: function (id) {
        return $http({
          method: 'DELETE',
          url: this.service.replace(/v1/, 'v2') + '/' + id
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service.replace(/v1/, 'v2'),
          data: {
            status: props.status,
            name: props.name,
            description: props.description,
            createdOn: props.createdOn,
            updatedOn: props.updatedOn,
            orderListResultCountLimit: props.orderListResultCountLimit,
            apiTimeoutInSecs: props.apiTimeoutInSecs,
            passcodes: props.passcodes,
            splash: props.splash,
            displayItems: props.displayItems,
            settings: props.settings,
            cacheRefreshIntervalInSecs: props.cacheRefreshIntervalInSecs,
            displayBrightnessPercent: props.displayBrightnessPercent,
            headerButtonConfig: props.headerButtonConfig
          }
        });
      },

      update: function(props, publish) {
        var url = this.service.replace(/v1/, 'v2');

        if (publish) {
          url += '?publish=true';
        }

        return $http({
          method: 'put',
          url: url,
          data: props
        });
      },

      publish: function(configId) {
        return $http({
          method: 'post',
          url: this.service.replace(/v1/, 'v2') + '/' + configId + '/publish'
        });
      },

      images: {

        service: '',

        list: function(configId) {
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + '/' + configId + '/images'
          });
        },

        remove: function(props) {
          return $http({
            method: 'delete',
            url: this.service.replace(/v1/, 'v2') + '/' + props.configId + '/images/' + props.imageId
          });
        }

      },

      pages: {

        service: '',

        list: function () {
          return $http({
            method: 'GET',
            url: '/assets/data/pages.json'
          });
        }

      },

      tiles: {

        list: function () {
          return $http({
            method: 'GET',
            url: '/assets/data/tiles.json'
          });
        }

      },

      navigation: {

        service: '',

        list: function () {
          return $http({
            method: 'GET',
            url: '/assets/data/pos-navigation.json'
          });
        },

        update: function (props) {
          return $http({
            method: 'put',
            url: '/assets/data/pos-navigation.json',
            data: props
          });
        }

      }

    };

}]);
